import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import ResponsiveTooltip from '../ResponsiveTooltip';
import useMessageService from '../../services/i18n/useMessageService';
import LocalizedMessage from '../LocalizedMessage';

const SUPPORTED_SYMBOLS = `! " # $ % & ' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ \` { | } ~`;
const UNSUPPORTED_SYMBOLS = `é, ñ, ü`;

const propTypes = {
    show: PropTypes.bool,
};

const InvalidPasswordCharactersInlineMessage = ({ show = false }) => {
    const [
        [
            passwordRequirementsInvalidCharacters = 'Enter a different password using {0}.',
            passwordRequirementsValidCharactersTooltipText = 'valid characters',
            passwordRequirementsInvalidCharactersTooltipContent = 'VeevaID passwords can only include letters, numbers, and supported symbols: {0}',
            passwordRequirementsInvalidCharactersTooltipContextExample = 'Accented letters (like {0}) and other non-ASCII characters are not allowed.',
        ],
        messageLoading,
    ] = useMessageService([
        'password_requirements.invalid_characters_inline_error',
        'password_requirements.valid_characters_tooltip_text',
        'password_requirements.invalid_characters_tooltip_content',
        'password_requirements.invalid_characters_tooltip_content_examples',
    ]);

    if (!show || messageLoading) {
        return null;
    }

    const tooltipContent = (
        <>
            <div>
                <LocalizedMessage
                    key="supportedSymbolsParagraph"
                    template={passwordRequirementsInvalidCharactersTooltipContent}
                    tokens={[SUPPORTED_SYMBOLS]}
                />
            </div>
            <div
                css={css`
                    margin-top: 1rem;
                `}
            >
                <LocalizedMessage
                    key="unsupportedSymbolsParagraph"
                    template={passwordRequirementsInvalidCharactersTooltipContextExample}
                    tokens={[UNSUPPORTED_SYMBOLS]}
                />
            </div>
        </>
    );

    return (
        <div
            css={css`
                text-align: left;
            `}
        >
            <LocalizedMessage
                template={passwordRequirementsInvalidCharacters}
                tokens={[
                    <ResponsiveTooltip key="invalidCharactersTooltip" content={tooltipContent}>
                        <span
                            css={css`
                                text-decoration: underline dotted;
                            `}
                        >
                            {passwordRequirementsValidCharactersTooltipText}
                        </span>
                    </ResponsiveTooltip>,
                ]}
            />
        </div>
    );
};

InvalidPasswordCharactersInlineMessage.propTypes = propTypes;

export default InvalidPasswordCharactersInlineMessage;
